import { render } from "./SimilarRecipes.vue?vue&type=template&id=440db51e&scoped=true"
import script from "./SimilarRecipes.vue?vue&type=script&lang=js"
export * from "./SimilarRecipes.vue?vue&type=script&lang=js"

import "./SimilarRecipes.vue?vue&type=style&index=0&id=440db51e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440db51e"]])

export default __exports__